/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandBilibili = createReactComponent("outline", "brand-bilibili", "IconBrandBilibili", [["path", { "d": "M3 10a4 4 0 0 1 4 -4h10a4 4 0 0 1 4 4v6a4 4 0 0 1 -4 4h-10a4 4 0 0 1 -4 -4v-6z", "key": "svg-0" }], ["path", { "d": "M8 3l2 3", "key": "svg-1" }], ["path", { "d": "M16 3l-2 3", "key": "svg-2" }], ["path", { "d": "M9 13v-2", "key": "svg-3" }], ["path", { "d": "M15 11v2", "key": "svg-4" }]]);

export { IconBrandBilibili as default };
//# sourceMappingURL=IconBrandBilibili.mjs.map
